import { createFeatureSelector, createSelector } from "@ngrx/store";
import type { CalendarState } from "./calendar.models";

export const selectCalendarState = createFeatureSelector<CalendarState>('calendar');

export const selectCalendarEvents = createSelector(
  selectCalendarState,
  (state) => state.events
);

export const selectCalendarRange = createSelector(
  selectCalendarState,
  (state) => state.range
);

export const selectCalendarLoading = createSelector(
  selectCalendarState,
  (state) => state.loading
);

export const selectCalendarError = createSelector(
  selectCalendarState,
  (state) => state.error
);

